import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'vf-info-popup',
  templateUrl: './info-popup.component.html'
})
export class InfoPopupComponent implements OnChanges {

  @Input() information: string;
  @Input() title: string = 'Insufficient Permissions';
  @Input() isShow: boolean;
  @Output() okClick = new EventEmitter();
  @ViewChild('infoPopup') infoPopup: ModalDirective;
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.doSomething(changes.isShow.currentValue);
  }

  doSomething(condition) {
    if (condition) {
      this.infoPopup.show();
      if ($('body > *').hasClass('modal-backdrop')) {
        $('body').removeClass('task-modal-body');
        $('.modal-backdrop:not(:first)').removeClass('modal-backdrop');
        $('body').addClass('center-modal-shown');
      }
    }
  }

  closeInfoPopup() {
    if ($('body').hasClass('center-modal-shown')) {
      if (!$('.right-side-bar-projects').hasClass('collapsed') ||
          $('#People').hasClass('show') ||
          !$('.right-side-bar-contacts').hasClass('collapsed') ||
          !$('.right-side-bar-files').hasClass('collapsed') ||
          $('.task-slider').hasClass('show') ||
          $('.task-modal-left').hasClass('show') ||
          $('.task-modal-right').hasClass('show')) {
            $('body').addClass('task-modal-body');
        }
      setTimeout(() => {
        $('body').removeClass('center-modal-shown');
      }, 1000);
    }
    this.infoPopup.hide();
    this.okClick.next();
  }

}
